<template>
  <path
    fill="currentColor"
    d="M10.891.46a1.567 1.567 0 0 1 2.217 0L23.54 10.892a1.566 1.566 0 0 1 0 2.217L13.108 23.541a1.568 1.568 0 0 1-2.217-2.217L20.213 12l-9.326-9.325A1.565 1.565 0 0 1 10.891.46Zm2.217 12.649a1.564 1.564 0 0 0 0-2.217L2.676.46A1.568 1.568 0 0 0 .459 2.677l9.322 9.322L.46 21.324a1.568 1.568 0 0 0 2.217 2.217l10.432-10.432Z"
  />
</template>
